<template>
  <div v-if="filteredFacilities.length > 0">
    <div class="truncate">
      <span
        v-for="(facility, index) in filteredFacilities"
        :key="`f${index}`"
        class="inline-block mr-6"
      >
        <fa
          class="fa-fw"
          :icon="getIcon(facility)"
        />
        <span
          class="ml-2"
          :data-i18n="`hotelFacility.${facility.trim()}`"
        >{{ $t(`hotelFacility.${facility.trim()}`) }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import charterHotelMixin from '@layers/web/mixins/charter-hotel.mixin'

export default defineNuxtComponent({
  mixins: [charterHotelMixin],
  props: {
    facilities: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    list () {
      return this.facilities || []
    },
    filteredFacilities () {
      return this.list.filter(facility => facility)
    },
  },
})
</script>